import React from 'react';
import { formatDate as formatDateGlobal, APP_CONFIG } from '../../config/appConfig';
import api from '../../services/api';
import type { Email } from './useData';
import { emailPartitionAtSearch } from './utils/emailPartitionAtQuery';

export const moduleConfig = {
  module: {
    title: 'Emails',
    description: 'View and manage emails',
    i18nKey: 'emails-module',
    route: {
      list: '/emails',
      new: '/emails/compose',
      detail: (id: number, partitionAt?: string | null) => `/emails/${id}${emailPartitionAtSearch(partitionAt)}`,
      edit: (id: number) => `/emails/${id}/edit`,
    },
    api: {
      list: '/emails',
      detail: (id: number, partitionAt?: string | null) => `/emails/${id}${emailPartitionAtSearch(partitionAt)}`,
    },
  },
  pagination: {
    initialItemsPerPage: APP_CONFIG.table.defaultPageSize,
    itemsPerPageOptions: APP_CONFIG.table.pageSizeOptions,
  },
  search: {
    placeholder: 'Search emails by subject, sender, or content...',
  },
  toolbar: {
    actions: [
      {
        key: 'add',
        icon: 'add',
        title: 'Compose Email',
        showTitle: false,
        href: '/emails/compose',
        variant: 'primary' as const,
      },
    ],
  },
  filters: {
    fields: [],
    applyFilter: (items: Email[]) => items,
  },
  fields: [],
  emptyStates: {
    noData: 'No emails found. Emails will appear here once synced from your email accounts.',
    noSearchResults: 'No emails found matching your search.',
    noFilterResults: 'No emails match the selected filters.',
  },
  delete: {
    title: 'Delete Email',
    message: 'Are you sure you want to delete this email? This action cannot be undone.',
    confirmText: 'Delete',
    cancelText: 'Cancel',
    errorMessage: 'Failed to delete email. Please try again.',
    handler: async (id: number, partitionAt?: string | null) => {
      await api.post(`/emails/${id}/delete${emailPartitionAtSearch(partitionAt)}`);
    },
  },
  utils: {
    formatDate: (dateString?: string) => {
      if (!dateString) return '-';
      return formatDateGlobal(dateString);
    },
  },
};

export const getToolbarIcon = (iconName: string): React.ReactNode => {
  switch (iconName) {
    case 'add':
      return (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
      );
    case 'sync':
      return (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      );
    default:
      return null;
  }
};
